import '../../css/mk-brand.css';
import MKCoin from '../../media/MK-coin.png';
import IngredientsIcon from '../../media/ingredients-icon.png';
import UtensilsIcon from '../../media/pots-and-pans.png';
import RecipesIcon from '../../media/recipe-icon.png';
import {useState, useEffect} from 'react';


function IngredientsUtensilsRecipesPanel() {
  useEffect(() => {
  },);
  // @ts-ignore
  return (
    <div id="chef-coin-collections" className="m-2">
      <div className="container max-w-6xl">
        <div className="bg-zinc-800 p-4 rounded-lg">
          <div className="flex justify-center p-4">
            <img src={MKCoin} className="max-h-16" />
            <h1 className="text-4xl sm:text-6xl font-extrabold text-center">$CHEF Coin Collections</h1>
            <img src={MKCoin} className="max-h-16" />
          </div>
          <hr/>
          <p className="md:mx-32 my-4 text-xl">
            <b>Ingredients</b> and <b>Utensils</b> are used in the Ready, Set, Whip mini game and later as core component of mKBattle. <b>Recipes</b> are used in mKBattle School and then as a core component of mKBattle. All of the NFTs described in this section can only be acquired through purchase with $CHEF or $SOL.
          </p>
          <div className="md:flex md:space-x-2 space-y-2 md:space-y-0">
            <div className="flex flex-col md:w-1/3 overflow-hidden bg-zinc-200 rounded-lg border border-black border-2 text-black pb-2">
              <div className="flex items-center p-10 bg-brand ">
                <span className="text-3xl text-brand-text">Ingredients</span>
              </div>
              <div className="px-4 space-y-2">
                <img src={IngredientsIcon} className="h-32 mx-auto my-4" />
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Food Groups:</b>
                  <ul className="list-disc px-4">
                    <li>Fruits and Vegetables</li>
                    <li>Meats and Proteins</li>
                    <li>Dairy</li>
                    <li>Grains</li>
                  </ul>
                </div>
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Rarity:</b> one to three stars
                </div>
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Taste:</b>
                  <ul className="list-disc px-4">
                    <li>Sweet</li>
                    <li>Sour</li>
                    <li>Salty</li>
                    <li>Bitter</li>
                    <li>Umami</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:w-1/3 overflow-hidden bg-zinc-200 rounded-lg border border-black border-2 text-black pb-2">
              <div className="flex items-center p-10 bg-brand ">
                <span className="text-3xl text-brand-text">Utensils</span>
              </div>
              <div className="px-4 space-y-2">
                <img src={UtensilsIcon} className="w-44 mx-auto -my-3" />
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Categories:</b>
                  <ul className="list-disc px-4">
                    <li>Spoons and Ladles</li>
                    <li>Sharp and Pointy stuff</li>
                    <li>Pots and Pans</li>
                    <li>Hammers, Presses, and Appliances</li>
                    <li>Whiskers, Peelers, Graters & Gadgets</li>
                  </ul>
                </div>
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Rarity:</b> one to three stars
                </div>
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Uses:</b>
                  <ul className="list-disc px-4">
                    <li>Dividing</li>
                    <li>Measuring & Mixing</li>
                    <li>Heating</li>
                    <li>Cooling</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:w-1/3 overflow-hidden bg-zinc-200 rounded-lg border border-black border-2 text-black pb-2">
              <div className="flex items-center p-10 bg-brand ">
                <span className="text-3xl text-brand-text">Recipes</span>
              </div>
              <div className="px-4 space-y-2">
                <img src={RecipesIcon} className="h-32 mx-auto my-4" />
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Cuisine:</b>
                  <ul className="list-disc px-4">
                    <li>European</li>
                    <li>Asian</li>
                    <li>American</li>
                    <li>Traditional</li>
                    <li>Indigenous</li>
                  </ul>
                </div>
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Rarity:</b> one to three stars
                </div>
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Secret:</b> some rare recipes are private to the owner.
                </div>
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Required Items:</b> A list of Ingredient and Utensil NFTs required to successfully execute the recipe.
                </div>
                <div className="rounded-lg bg-zinc-400 p-4 text-xl">
                  <b>Difficulty:</b> A star rating from one to five. You require a metaChef with a Rarity of at least as many stars as the Recipe in order to successfully execute the dish.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IngredientsUtensilsRecipesPanel;

